module.exports = __webpack_public_path__ + "img/imgVideo.28a1cac0.svg";